<script setup lang="ts">
defineProps<{
  label: string
  value: string
  showLabel?: boolean
  isLink?: boolean
}>()
</script>

<template>
  <div class="flex flex-col sm:flex-row sm:items-center gap-2 text-left">
    <h4
      v-if="showLabel"
      class="text-sm font-medium text-gray-500"
    >
      {{ label }}:
    </h4>
    <template v-if="isLink">
      <a
        :href="value"
        target="_blank"
        rel="noopener noreferrer"
        class="text-gray-900 no-underline flex items-center space-x-1 hover:opacity-75"
      >
        <span class="font-bold">{{ value.replace(/^https?:\/\//, '') }}</span>
        <Icon
          name="heroicons:link"
          class="w-4 h-4"
        />
      </a>
    </template>
    <p
      v-else
      class="text-gray-900"
    >
      {{ value }}
    </p>
  </div>
</template>
